<template>
  <div class="review-detail-container" style="overflow-x: hidden;">
    <!-- 加载状态 -->
    <div v-if="loading" v-loading="loading" element-loading-text="加载中..." style="min-height: 400px"></div>

    <!-- 内容区域 -->
    <div v-else-if="formData.inspectionCode">
      <!-- 物料信息 -->
      <b-card>
        <el-row :gutter="10">
          <div class="d-flex">
            <div class="side-frame"></div>
            <div>
              <span style="font-size: 14px; color: #606266">物料信息</span>
            </div>
          </div>
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 6 }"
          >
            <div class="d-flex">
              <div class="showTitle">
                <span>物料编码：</span>
              </div>
              <div class="showText">
                <span>{{ formData.materialNo }}</span>
              </div>
            </div>
          </el-col>
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 6 }"
          >
            <div class="d-flex">
              <div class="showTitle">
                <span>物料名称：</span>
              </div>
              <div class="showText">
                <span>{{ formData.materialName }}</span>
              </div>
            </div>
          </el-col>
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 6 }"
          >
            <div class="d-flex">
              <div class="showTitle">
                <span>CD#：</span>
              </div>
              <div class="showText">
                <span>{{ formData.cd }}</span>
              </div>
            </div>
          </el-col>
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 24 }"
            :md="{ span: 24 }"
            :lg="{ span: 6 }"
          >
            <div class="d-flex">
              <div class="showTitle">
                <span>规格型号：</span>
              </div>
              <div class="showText">
                <span>{{ formData.materialDesc }}</span>
              </div>
            </div>
          </el-col>

          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 24 }"
            :md="{ span: 12 }"
            :lg="{ span: 12 }"
          >
            <div class="d-flex">
              <div class="showTitle">
                <span>材质要求：</span>
              </div>
              <div class="showText">
                <span>{{ formData.materialRequirement }}</span>
              </div>
            </div>
          </el-col>
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 24 }"
            :md="{ span: 12 }"
            :lg="{ span: 12 }"
          >
            <div class="d-flex">
              <div class="showTitle">
                <span>系列：</span>
              </div>
              <div class="showText">
                <span>{{ formData.series }}</span>
              </div>
            </div>
          </el-col>

          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 6 }"
          >
            <div class="d-flex">
              <div class="showTitle">
                <span>采购单号：</span>
              </div>
              <div class="showText">
                <span>{{ formData.purchaseMaterialNo }}</span>
              </div>
            </div>
          </el-col>
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 6 }"
          >
            <div class="d-flex">
              <div class="showTitle">
                <span>源头单号：</span>
              </div>
              <div class="showText">
                <span>{{ formData.originOrderNo }}</span>
              </div>
            </div>
          </el-col>
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 6 }"
          >
            <div class="d-flex">
              <div class="showTitle">
                <span>采购人员：</span>
              </div>
              <div class="showText">
                <span>{{ formData.buyerName }}</span>
              </div>
            </div>
          </el-col>
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 6 }"
          >
            <div class="d-flex">
              <div class="showTitle">
                <span>供方：</span>
              </div>
              <div class="showText">
                <span>{{ formData.scmName }}</span>
              </div>
            </div>
          </el-col>
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 6 }"
          >
            <div class="d-flex">
              <div class="showTitle">
                <span>需方：</span>
              </div>
              <div class="showText">
                <span>{{ formData.purchaserEntityName }}</span>
              </div>
            </div>
          </el-col>
        </el-row>
      </b-card>

      <!-- 入库登记 -->
      <b-card>
        <el-row :gutter="10">
          <div class="d-flex">
            <div class="side-frame-success"></div>
            <div>
              <span style="font-size: 14px; color: #606266">入库登记</span>
            </div>
          </div>
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 6 }"
          >
            <div class="d-flex">
              <div class="showTitle">
                <span>实际到料日期：</span>
              </div>
              <div class="showText">
                <span>{{ formData.arrivalDate }}</span>
              </div>
            </div>
          </el-col>
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 6 }"
          >
            <div class="d-flex">
              <div class="showTitle">
                <span>来料总量：</span>
              </div>
              <div class="showText">
                <span>{{ formData.totalArrivalQuantity }}</span>
              </div>
            </div>
          </el-col>
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 24 }"
            :md="{ span: 12 }"
            :lg="{ span: 12 }"
          >
            <div class="d-flex">
              <div class="showTitle">
                <span>仓库收货人员：</span>
              </div>
              <div class="showText">
                <span>{{ formData.whReceiverNames }}</span>
              </div>
            </div>
          </el-col>
        </el-row>
      </b-card>

      <!-- 入库检验 -->
      <b-card>
        <el-row :gutter="10">
          <div class="d-flex">
            <div class="side-frame-warning"></div>
            <div>
              <span style="font-size: 14px; color: #606266">入库检验</span>
            </div>
          </div>
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 6 }"
          >
            <div class="d-flex">
              <div class="showTitle">
                <span>检验日期：</span>
              </div>
              <div class="showText">
                <span>{{ formData.inspectionDate }}</span>
              </div>
            </div>
          </el-col>
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 24 }"
            :md="{ span: 12 }"
            :lg="{ span: 18 }"
          >
            <div class="d-flex">
              <div class="showTitle">
                <span>检验人员：</span>
              </div>
              <div class="showText">
                <span>{{ formData.reporterNames }}</span>
              </div>
            </div>
          </el-col>

          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 6 }"
          >
            <div class="d-flex">
              <div class="showTitle">
                <span>抽检数量：</span>
              </div>
              <div class="showText">
                <span>{{ formData.totalInspectQuantity }}</span>
              </div>
            </div>
          </el-col>
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 6 }"
          >
            <div class="d-flex">
              <div class="showTitle">
                <span>抽检合格数量：</span>
              </div>
              <div class="showText">
                <span>{{ formData.totalQualifiedQuantity }}</span>
              </div>
            </div>
          </el-col>
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 6 }"
          >
            <div class="d-flex">
              <div class="showTitle">
                <span>不良数量：</span>
              </div>
              <div class="showText">
                <span :class="{ 'text-defective': formData.totalDefectiveQuantity > 0 }">{{ formData.totalDefectiveQuantity }}</span>
              </div>
            </div>
          </el-col>
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 6 }"
          >
            <div class="d-flex">
              <div class="showTitle">
                <span>合格率：</span>
              </div>
              <div class="showText">
                <span>{{ formData.totalQualifiedRate ? formData.totalQualifiedRate + '%' : '' }}</span>
              </div>
            </div>
          </el-col>
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 6 }"
          >
            <div class="d-flex">
              <div class="showTitle">
                <span>判定结果：</span>
              </div>
              <div class="showText">
                <span :class="inspectionResultClass">{{ inspectionResultText }}</span>
              </div>
            </div>
          </el-col>
        </el-row>
      </b-card>

      <!-- 重大问题 -->
      <b-card>
        <el-row :gutter="10">
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 24 }"
            :md="{ span: 24 }"
            :lg="{ span: 24 }"
          >
            <div>
              <div class="d-flex">
                <div class="side-frame-warning"></div>
                <div>
                  <span style="font-size: 14px; color: #606266">重大问题</span>
                </div>
              </div>
              <div class="table-container">
                <el-table
                  :data="majorIssueList"
                  border
                  size="small"
                  style="width: 100%"
                  :max-height="350"
                >
                  <el-table-column type="index" label="#" width="60" align="center" />
                  <el-table-column 
                    prop="defectIssuesTitle" 
                    label="重大问题" 
                    align="center" 
                    min-width="200"
                    :formatter="formatIssueTitle"
                  />
                  <template slot="empty">
                    <div style="text-align: center; padding: 20px 0">
                      <img src="/image/static/img/nodata.png" style="width: 100px" />
                      <p class="no-data">暂无数据</p>
                    </div>
                  </template>
                </el-table>
              </div>
            </div>
          </el-col>
        </el-row>
      </b-card>

      <!-- 疵点明细 -->
      <b-card>
        <el-row :gutter="10">
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 24 }"
            :md="{ span: 24 }"
            :lg="{ span: 24 }"
          >
            <div>
              <div class="d-flex">
                <div class="side-frame-warning"></div>
                <div>
                  <span style="font-size: 14px; color: #606266">疵点明细</span>
                </div>
              </div>
              <div class="table-container">
                <el-table
                  :data="defectList"
                  border
                  size="small"
                  style="width: 100%"
                  :max-height="350"
                  show-summary
                  :summary-method="getSummaries"
                >
                  <el-table-column type="index" label="#" width="60" align="center" />
                  <el-table-column 
                    prop="defectIssuesTitle" 
                    label="疵点" 
                    align="center" 
                    min-width="200"
                  />
                  <el-table-column 
                    prop="quantity" 
                    label="数量" 
                    width="120" 
                    align="center"
                  />
                  <template slot="empty">
                    <div style="text-align: center; padding: 20px 0">
                      <img src="/image/static/img/nodata.png" style="width: 100px" />
                      <p class="no-data">暂无数据</p>
                    </div>
                  </template>
                </el-table>
              </div>
            </div>
          </el-col>
        </el-row>
      </b-card>
    </div>

    <!-- 错误提示 -->
    <div v-else class="error-wrapper">
      <i class="el-icon-warning"></i>
      <p>{{ errorMsg || '数据加载失败' }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IqcInspectionReviewDetail',
  data() {
    return {
      loading: false,
      errorMsg: '',
      formData: {},
      majorIssueList: [],
      defectList: []
    }
  },
  beforeCreate() {
    document
      .querySelector('body')
      .setAttribute('style', 'background-color:#f1f1f1;')
  },
  computed: {
    inspectionResultText() {
      const result = this.formData.inspectionResult
      const inspectionResultMap = {
        Y: '合格',
        N: '不合格'
      }
      return inspectionResultMap[result] || '未判定'
    },
    inspectionResultClass() {
      const result = this.formData.inspectionResult
      if (result === 'Y') {
        return 'text-qualified'
      } else if (result === 'N') {
        return 'text-unqualified'
      }
      return ''
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    formatIssueTitle(row = {}) {
      const title = (row.defectIssuesTitle || '').trim()
      const otherProblemDesc = `${row.otherProblemDesc || ''}`.trim()
      if (title === '其他' && otherProblemDesc) {
        return `${title}：${otherProblemDesc}`
      }
      return title
    },
    async getData() {
      const inspectionCode = this.$route.params.code
      
      if (!inspectionCode) {
        this.errorMsg = '缺少检验单号参数'
        return
      }

      this.loading = true
      
      try {
        const res = await this.$api.opaGetMaterialInspectionApi(inspectionCode)

        if (res.status === 200 && res.body) {
          this.formData = res.body
          this.majorIssueList = res.body.majorIssueList || []
          this.defectList = res.body.defectList || []
        } else {
          this.errorMsg = res.msg || '数据加载失败'
        }
      } catch (error) {
        console.error('Load review detail error:', error)
        this.errorMsg = error.message || '数据加载失败'
      } finally {
        this.loading = false
      }
    },
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = ''
          return
        }
        if (index === 1) {
          sums[index] = '合计'
          return
        }
        if (column.property === 'quantity') {
          const values = data.map(item => Number(item[column.property]))
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0)
          } else {
            sums[index] = ''
          }
        } else {
          sums[index] = ''
        }
      })
      return sums
    }
  }
}
</script>

<style lang="scss" scoped>
.review-detail-container {
  min-height: 100vh;
  background-color: #f1f1f1;
}

.card {
  margin: 10px 10px;
}

.side-frame {
  padding: 1px 5px;
  border-left: 3px solid $color-primary;
  height: 20px;
  margin: 3px 0 10px 0;
}

.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin: 3px 0 10px 0;
}

.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin: 3px 0 10px 0;
}

.showTitle {
  font-size: 14px;
  color: $color-text-sub;
  width: 110px;
  min-width: 110px;
}

.showText {
  font-size: 14px;
  color: $color-text-normal;
  width: 100%;
}

.text-qualified {
  color: #28A745;
  font-weight: 600;
}

.text-unqualified {
  color: #DC3545;
  font-weight: 600;
}

.text-defective {
  color: #f95271;
  font-weight: 600;
}

.table-container {
  margin-top: 10px;

  .no-data {
    margin-top: 10px;
    font-size: 14px;
    color: #909399;
  }

  :deep(.el-table__footer-wrapper) {
    .el-table__footer {
      background-color: #f5f7fa;
      font-weight: 600;
      
      .cell {
        text-align: center;
      }
    }
  }
}

.error-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  color: #909399;
  
  i {
    font-size: 48px;
    margin-bottom: 16px;
  }
  
  p {
    font-size: 14px;
  }
}
</style>
